import { MortgageInsuranceDiscontinuanceCode as GqlMortgageInsuranceDiscontinuanceCode } from '@willow/graphql-iso/src/app/backend';
import { MortgageInsuranceDiscontinuanceCode as IsoMortgageInsuranceDiscontinuanceCode } from '@willow/types-iso';

export const ISO_TO_GQL_MORTGAGE_INSURANCE_DISCONTINUANCE_CODE: Record<
  IsoMortgageInsuranceDiscontinuanceCode,
  GqlMortgageInsuranceDiscontinuanceCode
> = {
  borrowerInitiatedDueToOriginalValue: GqlMortgageInsuranceDiscontinuanceCode.BorrowerInitiatedDueToOriginalValue,
  borrowerInitiatedDueToCurrentValue: GqlMortgageInsuranceDiscontinuanceCode.BorrowerInitiatedDueToCurrentValue,
  automaticDueToLTVOrMidpointValue: GqlMortgageInsuranceDiscontinuanceCode.AutomaticDueToLtvOrMidpointValue,
  terminatedDueToHighRisk: GqlMortgageInsuranceDiscontinuanceCode.TerminatedDueToHighRisk,
};
